<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <div class="row justify-content-center">
    <h1 class="lifedi-color">
      แจ้งโอน
    </h1>
  </div>

  <mat-card>
    <form [formGroup]="evidenceForm">
      <div class="form-group row d-flex justify-content-center">
        <label class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label" style="font-size: medium;">
          วันที่ชำระเงิน
        </label>
        <div class="col-8 col-sm-9 col-md-6 col-lg-5">
          <div class="input-group">
            <!-- <input class="form-control" type="date" date-format="YYYY-mm-dd" formControlName="TRANFER_DATE"> -->
            <input type="text" id="date" class="form-control" formControlName="TRANFER_DATE" bsDatepicker
              date-format="YYYY-mm-dd" autocomplete="off"
              value="{{ evidenceForm.value.TRANFER_DATE | date:'DD/MM/YYYY' }}"
              [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }" [maxDate]="today">
          </div>
        </div>
      </div>
      <div class="form-group row d-flex justify-content-center">
        <label class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label" style="font-size: medium;">
          เวลา
        </label>
        <div class="col-8 col-sm-9 col-md-6 col-lg-5">
          <div class="row">
            <div class="input-group" style="background: #fff; width: 100%;">
              <div class="col-6">
                <input type="number" class="form-control" min="0" max="23" formControlName="TRANFER_HR" pattern="[0-9]*"
                  (keyup)="time($event, 'hr')" placeholder="ชั่วโมง">
              </div>
              <div class="col-6">
                <input type="number" class="form-control" min="0" max="59" formControlName="TRANFER_MIN"
                  pattern="[0-9]*" (keyup)="time($event, 'min')" placeholder="นาที">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row d-flex justify-content-center">
        <label class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label" style="font-size: medium;">
          จำนวนเงิน
        </label>
        <div class="col-8 col-sm-9 col-md-6 col-lg-5">
          <input type="number" class="form-control" formControlName="TRANFER_PRICE" [(ngModel)]="price">
        </div>
      </div>

      <div class="form-group row d-flex justify-content-center">
        <label for="coursePic" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label"
          style="font-size: medium;">หลักฐานการโอน</label>
        <div class="col-8 col-sm-9 col-md-6 col-lg-5">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="slip" accept=".png, .jpg, .jpeg"
              (change)="onSlipSelected($event, evidenceForm)">
            <label class="custom-file-label" for="slip">Choose file</label>
            <label *ngIf="!slip" class="custom-file-label" for="slip">Choose file</label>
            <label *ngIf="slip" class="custom-file-label" for="slip">{{ slip }}</label>
          </div>
        </div>
      </div>

      <div *ngIf="slip" class="row">
        <div class="col d-flex justify-content-center">
          <img [src]="slipPic" alt="" class="img-fluid mx-auto d-block mt-3 mb-5" style="width: 400px;">
        </div>
      </div>

      <div class="form-group row d-flex justify-content-center">
        <label for="coursePic" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label"
          style="font-size: medium;">หลักฐานส่วนลด</label>
        <div class="col-8 col-sm-9 col-md-6 col-lg-5">
          <div class="custom-file">
            <nz-upload
              nzAccept=".png, .jpg, .jpeg, .pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              [nzShowUploadList]="{ showRemoveIcon: true ,showDownloadIcon: false }" [nzCustomRequest]="successRequest"
              [nzFileList]="fileList" nzListType="picture" (nzChange)="handleChange($event, evidenceForm)">
              <button nz-button style="width: 100%;">Choose File</button>
            </nz-upload>
          </div>
        </div>
      </div>

    </form>

    <div class="row my-5 py-2">
      <div class="col-12 d-flex justify-content-center">
        <lifedi-btn *ngIf="evidenceForm.valid" (click)="paid(evidenceForm.value)" lable="แจ้งโอน"
          customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
        </lifedi-btn>
        <lifedi-btn *ngIf="!evidenceForm.valid" lable="แจ้งโอน" disabled="true"
          customStyle="background-color: #aaa; color: #FFF; margin: 0px; padding: 0 30px;">
        </lifedi-btn>
      </div>
    </div>

  </mat-card>

  <div *ngIf="isLoading">
    <div
      style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
  </div>


</div>